var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login-change" } }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-toggle",
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window"
              }
            },
            [
              _c("img", {
                staticClass: "d-none d-lg-inline-block",
                attrs: {
                  src: _vm.pluginPathTheme + "/images/user-login.svg",
                  alt: "user"
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "d-lg-none",
                attrs: {
                  src: _vm.pluginPathTheme + "/images/user-login-white.svg",
                  alt: "user"
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-sm-inline" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Template.loginHello", {
                      username: _vm.username
                    })
                  )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "account-menu dropdown-menu dropdown-menu-right small m-0 p-0 mw-100"
            },
            [
              _c(
                "div",
                {
                  staticClass: "list-group",
                  attrs: { "aria-labelledby": "accountMenuList" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "list-group-item small",
                      attrs: { href: _vm.$ceres.urls.myAccount }
                    },
                    [
                      _c("img", {
                        staticClass: "d-none d-lg-inline-block",
                        attrs: {
                          src: _vm.pluginPathTheme + "/images/user-login.svg",
                          alt: "user"
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "d-lg-none",
                        attrs: {
                          src:
                            _vm.pluginPathTheme +
                            "/images/user-register-white.svg",
                          alt: "user"
                        }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginMyAccount")
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      staticClass: "list-group-item small",
                      attrs: { href: "#" }
                    },
                    [
                      _c("i", { staticClass: "fa fa-sign-out" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c(
          "div",
          [
            _vm.showLogin
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal"
                    },
                    on: {
                      click: function($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "d-none d-lg-inline-block",
                      attrs: {
                        src: _vm.pluginPathTheme + "/images/user-login.svg",
                        alt: "user"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "d-lg-none",
                      attrs: {
                        src:
                          _vm.pluginPathTheme + "/images/user-login-white.svg",
                        alt: "user"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "d-none d-sm-inline" }, [
                      _vm._v(_vm._s(_vm.$translate("Ceres::Template.login")))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showRegistration
              ? [
                  !_vm.showLogin
                    ? _c("span", { staticClass: "pipe" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.$ceres.urls.registration } }, [
                    _c("img", {
                      staticClass: "d-none d-lg-inline-block",
                      attrs: {
                        src: _vm.pluginPathTheme + "/images/user-regsiter.svg",
                        alt: "user"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "d-lg-none",
                      attrs: {
                        src:
                          _vm.pluginPathTheme +
                          "/images/user-register-white.svg",
                        alt: "user"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "d-none d-sm-inline" }, [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.loginRegister"))
                      )
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }